module.exports = __webpack_public_path__ + "img/file-ruled-fill.9ab68d7c.svg";